import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class ChancenReminder extends MongoEntity {
  public static override _class = 'ChancenReminder';
  public static override _collectionName = 'reminders';

  @Field(type => Date) public dueDate!: Date;
  @Field(type => Boolean) public isSent: Maybe<boolean>;
}

@Entity()
export class LogistikOrderReminder extends ChancenReminder {
  public static override _class = 'LogistikOrderReminder';

  @Field(type => ID) public orderID!: string;
}
